import {get} from '@logistics-frontend/utils'

import type {DestinationPoint, PointType, ReturnPoint, SourcePoint} from 'src/shared/types'

export const getPointType: (point: SourcePoint | DestinationPoint | ReturnPoint) => PointType = get('_type')
